/* eslint camelcase: 0 */
import { request } from "../helpers/axios.new";

export const GET_BUSINESS_LOCATIONS = ({access_token, token_type}) => {
  return request({
    url: `/google/business/locations?access_token=${access_token}&token_type=${token_type}`,
    method: "GET",
  });
};